import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { buildXrhubAppRedirectUrl } from "../../utils/xrhubRedirect.js";

export default function XrhubCatchAllRedirect({ location, xrhubUrl, creatorBasePath, navigate }) {
  useEffect(() => {
    const routeLocation = location || window.location;
    const redirectUrl = buildXrhubAppRedirectUrl(
      `${routeLocation.pathname}${routeLocation.search || ""}${routeLocation.hash || ""}`,
      {
        xrhubUrl,
        locationOrigin: window.location.origin,
        creatorBasePath
      }
    );

    navigate(redirectUrl);
  }, [creatorBasePath, location, navigate, xrhubUrl]);

  return null;
}

XrhubCatchAllRedirect.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string,
    search: PropTypes.string
  }),
  navigate: PropTypes.func,
  xrhubUrl: PropTypes.string,
  creatorBasePath: PropTypes.string
};

XrhubCatchAllRedirect.defaultProps = {
  navigate: url => window.location.assign(url)
};
